<template>
  <div class="title-info" :class="className">
    <span class="dot dot-l"></span>五行属{{titleText}}<span class="dot dot-r"></span>
  </div>
</template>

<script>
export default {
  name: 'TipsInfo',
  props: {
    className: {
      type: String,
      default() { return ''}
    },
    titleText: {
      type: String,
      default() { return ''}
    }
  },
  data() {
    return {};
  }
}
</script>

<style scoped>
.title-info {
  width: 10rem;
  height: 1.35rem;
  line-height: 1.35rem;
  text-align: center;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 500;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center center;

  position: relative;
  margin: 0 auto;
}
.title-info.solid { background-image: url('../../assets/images/dress/bg-title-solid.png'); }
.title-info.wood { background-image: url('../../assets/images/dress/bg-title-wood.png'); }
.title-info.fire { background-image: url('../../assets/images/dress/bg-title-fire.png'); }
.title-info.gold { background-image: url('../../assets/images/dress/bg-title-gold.png'); }
.title-info.water { background-image: url('../../assets/images/dress/bg-title-water.png'); }
.title-info .dot {
  display: block;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: #fff;

  position: absolute;
  top: 0.5rem;
}
.title-info .dot.dot-l {
  left: 2rem;
}
.title-info .dot.dot-r {
  right: 2rem;
}
</style>
